import _ from "underscore";

/**
 * @description Groups items from an array into an array of objects, grouped by a property 'prop' name, maintaining original order. Based on functionality of LoDash's 'groupBy' function, but, unlike LoDash, preserves original array's order and returns an array instead of an object.
 * @param arr {array of objects} - Objects within array should contain a property marked by the 'prop' argument, or else they will be excluded from the output and a warning will be logged.
 * @param prop {string} Propery to use for grouping. The value of this will be converted to a string when creating group names.
 */
const groupByKeepOrder = function <T>(arr: T[], prop: keyof T) {
    var newArr: T[][] = [], // array to return, keeps track of order
        wrapObj: any = {}; // temporary object used for grouping

    _.forEach(arr, function (item) {
        // gets property name to group by and converts it to a string for grouping purposes
        let propName = item[prop];
        if (propName) {
            //   propName = propName.toString();

            // checks if group exists already and creates a new group if not, pushing it into the array to return ('newArr')
            if (!wrapObj[propName]) {
                wrapObj[propName] = [];
                newArr.push(wrapObj[propName]);
            }

            // adds item to the group
            wrapObj[propName].push(item);
        } else {
            console.warn(
                "utils -> groupByKeepOrder",
                "Property '" +
                    prop +
                    "' not found within object. It will be ignored from the output.",
                item
            );
        }
    });

    //   delete wrapObj; // don't need this anymore
    return newArr;
};

export default groupByKeepOrder;
